import { Carousel } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomModal } from "../../../../components";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { usePopupContext } from "../../context/PopupContext";
import { popupSortingEnum } from "../../enumeration/popupSortingEnum";
import "./style";
import styles from "./styleModule";

const MarqueePopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkIfLogin } = useLogin();
  const { data, sorting, setNextSorting } = usePopupContext();
  const [modalNotice, setModalNotice] = useState();
  const [showNoticeModal, setShowNoticeModal] = useState(false);

  const closeModal = () => {
    setNextSorting();
    setShowNoticeModal(false);
  };

  const ModalContentRender = () => {
    return (
      <div className="custom-notice-carousel">
        <Carousel
          afterChange={(currentSlide) => {
            // console.log(currentSlide);
          }}
        >
          {modalNotice?.map((notice, index) => {
            return (
              <div key={"notice" + index}>
                <div>
                  <div className="notice-title">{notice.title}</div>
                  <div
                    className="notice-content"
                    dangerouslySetInnerHTML={{ __html: notice.content }}
                  />
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  };

  const setTomorrowCheck = (noticeId) => {
    setShowNoticeModal(true);
    const tomorrowTime = new Date(new Date().toLocaleDateString()).getTime() + 86400000;
    const tomorrowCheckTime = JSON.parse(localStorage.getItem(localStorageKey.NOTICE_READ_RECORD));
    let newTomorrowCheck = { ...tomorrowCheckTime };
    if (tomorrowCheckTime) {
      newTomorrowCheck = { ...newTomorrowCheck, [noticeId]: tomorrowTime };
    } else {
      newTomorrowCheck = { [noticeId]: tomorrowTime };
    }
    localStorage.setItem(localStorageKey.NOTICE_READ_RECORD, JSON.stringify(newTomorrowCheck));
  };

  useEffect(() => {
    if (!data || popupSortingEnum["noticeReadTime"].sorting !== sorting) return;
    let popupNotice = data?.filter((item) => item.position === 3);
    setModalNotice(popupNotice);

    if (popupNotice?.length > 0) {
      const tomorrowCheckTime = JSON.parse(
        localStorage.getItem(localStorageKey.NOTICE_READ_RECORD),
      );
      popupNotice?.map((item) => {
        if (!tomorrowCheckTime) {
          setTomorrowCheck(item.id);
          return item;
        }
        if (!Object.keys(tomorrowCheckTime).includes(item.id.toString())) {
          setTomorrowCheck(item.id);
          return item;
        }
        const nowTime = new Date().getTime();
        if (nowTime - tomorrowCheckTime[item.id] >= 0) {
          setTomorrowCheck(item.id);
          return item;
        }
        if (!showNoticeModal) setNextSorting();
        return item;
      });
    } else {
      setNextSorting();
    }
  }, [setNextSorting, sorting, data]);

  return (
    <CustomModal
      isModalVisible={showNoticeModal}
      setIsModalVisible={setShowNoticeModal}
      title={t("notice.important")}
      content={ModalContentRender}
      okBtnText={t("normal.toCheck")}
      cancelBtnText={t("normal.close")}
      contentContainerStyle={styles.modalContainerStyle}
      onOk={() => {
        if (!checkIfLogin()) return;
        setShowNoticeModal(false);
        navigate("/announce");
      }}
      onCancel={() => closeModal()}
    />
  );
};

export default MarqueePopup;
